import { useState } from "react";
import LivelinessCheckModal from "../../Property/Purchase/components/LivelinessCheckModal";
import LiveCheck from "./LivelinessModal";

const teamMembers = [
  {
    name: "Christopher Ifechukwude Epum",
    role: "Project Manager, Home and Abroad Platform",
    bio: `Christopher is the Project Manager of the Home and Abroad Platform, driving strategy, partnerships, and execution to connect Nigerians in the diaspora with the local real estate market. With over 10 years’ experience in e-commerce, business development, and project management, he has led scalable digital marketplace solutions and delivered measurable growth across multiple sectors.
    Christopher has successfully managed multiple projects, built strategic collaborations, and managed stakeholder engagement.`,
    image: "/assets/images/chris.jpg",
  },
  {
    name: "Owhorchukwu Onuegbu ",
    role: "Partnerships and New Business",
    bio: `Owhorchukwu is a seasoned business development and customer relationship expert with over five years of experience in Real Estate and Financial Technology.

He has successfully led numerous teams and managed over 500 consultants across diverse real estate products. Additionally, he headed the strategic business unit for Muritala Muhammed 2 Airport. Throughout his career, Owhorchukwu has closed, as well as supported the closing of, multiple seven-figure sales deals.`,
    image: "/assets/images/owhorchukwu.jpeg",
  },
  {
    name: "Queeneth Akang",
    role: "Legal Head",
    bio: `Queeneth is a seasoned legal professional with over a decade of expertise in corporate, commercial, IP law, data privacy, compliance, and advocacy. She holds an LL.M from the University of Lagos, is a Chartered Tax Consultant, and a member of the Chartered Institute of Secretaries and Administrators of Nigeria.
Currently Head Legal Advisor at Sydani Group, she has streamlined contract processes, strengthened governance, and reduced litigation risks. Previously, she served as Industrial Relations Manager at Dangote Group and Legal Manager at Emmaneth Global.`,
    image: "/assets/images/queeneth.jpg",
  },
];

const TheTeam = () => {
  const [showLivelinessCheckModal, setShowLivelinessCheckModal] =
    useState(false);
  const [livelinessScore, setLivelinessScore] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [score, setScore] = useState(0);
  return (
    <div className="bg-textWhite px-6 lg:px-[54px] flex py-10 lg:py-0 flex-col gap-14 lg:gap-10 items-center justify-center w-full">
      <h3 className="text-textBlack text-[36px] font-poppins font-semibold">
        Meet the team
      </h3>

      <p onClick={() => setModalOpen(true)}>Liveliness Score: {score}</p>
      {modalOpen && (
        <LiveCheck
          showModal={modalOpen}
          // onCloseModal={() => setShowLivelinessCheckModal(false)}
          onCloseModal={() => setModalOpen(false)}
          _setScore={setScore}
        />
      )}
      {showLivelinessCheckModal && (
        <LivelinessCheckModal
          showModal={showLivelinessCheckModal}
          // onCloseModal={() => setShowLivelinessCheckModal(false)}
          onCloseModal={() => setShowLivelinessCheckModal(false)}
          _setScore={setLivelinessScore}
        />
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[35px]">
        {teamMembers.map((member, i) => (
          <div
            className="flex flex-col gap-4 py-8 lg:py-5  p-5 shadow-custom2 rounded-[10px] items-center justify-"
            key={i}
            style={{
              boxShadow:
                "0px 0.5px 0px 0.5px #00000026, 0px 1px 0.5px 0px #0000004D",
            }}
          >
            <div className="w-[100px] lg:w-[167px] h-[100px] lg:h-[167px] rounded-full bg-[#F1F0EE] border-[3px] border-primary">
              <img
                src={member.image}
                className="rounded-full h-full w-full object-cover"
                alt=""
              />
            </div>
            <div className="py-4 flex flex-col gap-4 items-center justify-center">
              <div className="">
                <h3 className="text-textBlac3 text-center text-[22px] font-poppins font-medium">
                  {member.name}
                </h3>
                <p className="text-textBlack3 text-[15px] text-center leading-[22px] font-[300] tracking-[0%] font-poppins">
                  {member.role}
                </p>
              </div>
              <p className="whitespace-pre-line text-[13px] text-textBlack3 text-center leading-[22px] font-[300] leading-[20px] tracking-[0%] font-poppins">
                {member.bio}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TheTeam;
